import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import BestiesApp from './BestiesApp'; // ✅ make sure file name matches exactly

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<BestiesApp />);